import * as React from "react";
import { ChangeEvent, ReactNode } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select, SelectChangeEvent,
  styled,
} from "@mui/material";
import { ConfigurationDottedKey } from "@kahunmedical/common-configuration/dist/lib/annotations";

//region [[ Styles ]]

const SelectOptionsDropdownView = styled(FormControl)({
  minWidth: "85px",
});

const OptionsSelect = styled(Select)({
  background: "white",
  borderRadius: "3px",
  boxShadow: "0px 0px 3px rgb(0 0 0 / 4%)",
  "& .MuiSelect-select.MuiSelect-select": {
    padding: "12px 34px 12px 14px",
  },
  "&::before": {
    content: '""',
    display: "none",
  },
  "&::after": {
    content: '""',
    display: "none",
  },
});

const OptionLabel = styled("div")({
  color: "#5C5C5D",
  fontWeight: 600,
  fontSize: "10px",
  width: "100%",
  textAlign: "center",
  "&.selected": {
    color: "#008A37",
  },
  "&.option": {
    textAlign: "left",
    color: "#243443",
  },
  ".disabled &.option, .disabled &.selected": {
    color: "#999999",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SelectOptionsDropdownProps {
  value: string;
  options: Record<string, any>;
  optionKey: ConfigurationDottedKey;
  onChange: (newValue: any) => void;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SelectOptionsDropdown = ({
  ...props
}: SelectOptionsDropdownProps) => {
  const dropDownLabelId = `options-select-label-${props.optionKey}`;
  const dropDownId = `options-select-label-${props.optionKey}`;

  const handleSelections = (
      event: SelectChangeEvent
  ) => {
    props.onChange(event.target.value);
  };

  return (
    <>
      <SelectOptionsDropdownView>
        <OptionsSelect
          labelId={dropDownLabelId}
          id={dropDownId}
          value={props.value}
          onChange={handleSelections}
          renderValue={(selected:any) => {
            if (!selected) {
              return <OptionLabel>OPTIONS</OptionLabel>;
            }
            return <OptionLabel className={"selected"}>{selected}</OptionLabel>;
          }}
          displayEmpty
          disabled={props.disabled}
          className={props.disabled ? "disabled" : ""}
        >
          <MenuItem value={""}>
            <OptionLabel>OPTIONS</OptionLabel>
          </MenuItem>
          {Object.entries(props.options || {}).map?.(([option, value]) => (
            <MenuItem value={value} key={option}>
              <OptionLabel className={"option"}>{value}</OptionLabel>
            </MenuItem>
          ))}
        </OptionsSelect>
      </SelectOptionsDropdownView>
    </>
  );
};
